export { OtelAttributes, createFormAttributes } from './attributes'
export type { OtelAttributeValue, OtelAttributeRecord } from './types'
